import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Avatar } from '@mui/material';
import { USERS } from '../../../core/router/routes';
import { useUserCore } from '../../../core/modules/user';
import { useCallback, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import RoleChip from '../RoleChip';

const Header = () => {
  const { t } = useTranslation();
  const { user, putBlockUser, putUnblockUser, getUser } = useUserCore();

  const [loading, setLoading]  = useState(false);

  const onChangingStatus = useCallback(() => {
    setLoading(true);
    if (user?.active) {
      putBlockUser(user?.id, () => {
        getUser(user.id, () => {
          setLoading(false);
        });
      });
    } else {
      putUnblockUser(user?.id!, () => {
        getUser(user?.id!, () => {
          setLoading(false);
        });
      });
    }
  }, [user, putBlockUser, putUnblockUser, getUser]);

  return (
    <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between space-y-8 sm:space-y-0 py-32 px-24 md:px-32">
      <div className="flex flex-col items-center sm:items-start space-y-8 sm:space-y-0 w-full sm:max-w-full min-w-0">
        <Typography
          className="flex items-center sm:mb-12"
          component={Link}
          role="button"
          to={USERS}
          color="inherit"
        >
          <ArrowBackOutlinedIcon />
          <span className="flex mx-4 font-medium">{t('user.link.users')}</span>
        </Typography>

        <div className="flex items-center max-w-full">
          <div className="hidden sm:flex">
            {user?.avatar ? (
              <Avatar
                alt="project photo"
                className="w-84 h-84"
                src={user?.avatar}
              />
            ) : (
              <Avatar className="w-84 h-84">{user?.full_name[0]}</Avatar>
            )}
          </div>
          <div className="flex flex-col items-center sm:items-start min-w-0 mx-8 sm:mx-16">
            <Typography className={clsx("text-16 sm:text-20 truncate font-semibold", user?.active ? 'text-slate-950' : 'text-red-700')}>
              {user?.full_name}
            </Typography>
            {user && <RoleChip isSuperuser={user?.is_superuser} role={user?.role}/>}
            <Typography variant="caption" className="font-medium">
              {t('user.label.details')}
            </Typography>
          </div>
        </div>
      </div>
      <div className="flex">
        <Button
          className="whitespace-nowrap mx-4"
          variant="contained"
          color={user?.active ? "error" : "warning"}
          startIcon={<BlockOutlinedIcon />}
          onClick={onChangingStatus}
          disabled={loading}
        >
          {user?.active ? t('button.block') : t('button.unblock')}
        </Button>
      </div>
    </div>
  );
};

export default Header;
